import { render, staticRenderFns } from "./VehicleDamage.vue?vue&type=template&id=07a2a9c2"
import script from "./VehicleDamage.vue?vue&type=script&lang=js"
export * from "./VehicleDamage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports